import type { ElementType, ReactElement } from "react";

import { styled } from "simplydo/react/styled";

import type { TableBodyProps } from "./Table.types";

const TableBodyComponent = (props: TableBodyProps): ReactElement => {
  const { as, className, style, children } = props;
  const Component = (as || "tbody") as ElementType;
  return (
    <Component className={className} style={style}>
      {children}
    </Component>
  );
};

export const TableBody = styled(TableBodyComponent)``;
